import { render, staticRenderFns } from "./Western.vue?vue&type=template&id=8bd4fdba&scoped=true&"
import script from "./Western.vue?vue&type=script&lang=js&"
export * from "./Western.vue?vue&type=script&lang=js&"
import style0 from "./Western.vue?vue&type=style&index=0&id=8bd4fdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd4fdba",
  null
  
)

export default component.exports